<template>
  <div class="nc-pagina">

    <!-- ENCABEZADO -->
    <div class="nc-tarjeta">
      <div class="nc-tarjeta-cabecera">
        <span>Nota de Crédito</span>
      </div>
      <div class="nc-tarjeta-cuerpo">
        <div class="nc-grid-4">
          <div class="nc-campo">
            <label class="campo-etiqueta">Fecha Emisión</label>
            <input type="date" class="campo-input" v-model="cabecera.fechaEmision" />
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Punto Emisión</label>
            <select class="campo-select" v-model="cabecera.puntoEmisionId" :disabled="cargandoPuntos">
              <option v-if="cargandoPuntos" disabled value="">Cargando...</option>
              <option v-else-if="puntosEmision.length === 0" disabled value="">Sin puntos</option>
              <option v-for="p in puntosEmision" :key="p.id" :value="p.id">{{ p.full_code }}</option>
            </select>
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Ambiente</label>
            <input type="text" class="campo-input" v-model="cabecera.ambiente" disabled />
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Secuencial</label>
            <input
              type="text"
              class="campo-input"
              :value="cargandoSecuencial ? 'Cargando...' : (secuencial || 'Sin secuencial')"
              disabled
            />
          </div>
        </div>
      </div>
    </div>

    <!-- DATOS DEL COMPRADOR -->
    <div class="nc-tarjeta">
      <div class="nc-tarjeta-cabecera">Datos del Comprador</div>
      <div class="nc-tarjeta-cuerpo">
        <div class="nc-grid-4">
          <div class="nc-campo">
            <label class="campo-etiqueta">Tipo Identificación</label>
            <select class="campo-select" v-model="comprador.tipoIdentificacion">
              <option value="">Seleccione</option>
              <option v-for="tipo in sriTypes" :key="tipo.code" :value="tipo.code">{{ tipo.name }}</option>
            </select>
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Identificación</label>
            <div class="campo-con-spinner">
              <input
                type="text"
                class="campo-input"
                v-model="comprador.identificacion"
                placeholder="RUC / Cédula / Pasaporte"
                @blur="buscarCompradorAutomatico('identificacion')"
                @keyup.enter="buscarCompradorAutomatico('identificacion')"
              />
              <span v-if="buscandoCliente" class="campo-spinner-dot"></span>
            </div>
          </div>
          <div class="nc-campo nc-campo-doble">
            <label class="campo-etiqueta">Razón Social</label>
            <div class="campo-relativo">
              <div class="campo-con-spinner">
                <input
                  type="text"
                  class="campo-input"
                  placeholder="Ingrese nombre o razón social"
                  v-model="comprador.razonSocial"
                  @input="buscarCompradorMientrasEscribe"
                  @blur="cerrarSugerenciasConDelay"
                  @keydown.down.prevent="navegarSugerencia(1)"
                  @keydown.up.prevent="navegarSugerencia(-1)"
                  @keydown.enter.prevent="seleccionarSugerenciaActiva"
                  @keydown.escape="cerrarSugerencias"
                  autocomplete="off"
                />
                <span v-if="buscandoCliente" class="campo-spinner-dot"></span>
              </div>
              <ul
                v-if="sugerenciasClientes.length > 0 && mostrarSugerencias"
                class="sugerencias-lista"
              >
                <li
                  v-for="(cliente, index) in sugerenciasClientes"
                  :key="cliente.id"
                  class="sugerencia-item"
                  :class="{ 'sugerencia-activa': index === indiceSugerenciaActiva }"
                  @mousedown.prevent="seleccionarCliente(cliente)"
                >
                  <div class="sugerencia-nombre">{{ cliente.business_name }}</div>
                  <div class="sugerencia-id">{{ cliente.identification_number }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Correo</label>
            <input type="email" class="campo-input" v-model="comprador.correo" />
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Dirección</label>
            <input type="text" class="campo-input" v-model="comprador.direccion" />
          </div>
        </div>
      </div>
    </div>

    <!-- FACTURA MODIFICADA -->
    <div class="nc-tarjeta">
      <div class="nc-tarjeta-cabecera">Documento Modificado</div>
      <div class="nc-tarjeta-cuerpo">
        <div class="nc-grid-3">
          <div class="nc-campo">
            <label class="campo-etiqueta">Número de Factura <span class="campo-requerido">*</span></label>
            <div class="campo-con-boton">
              <input
                type="text"
                class="campo-input"
                placeholder="Ej: 001-001-000000001"
                v-model="docModificado.numero"
                disabled
              />
              <button
                class="btn-campo"
                @click="abrirModalFacturas"
                :disabled="buscandoFactura || !comprador.identificacion.trim()"
                :title="!comprador.identificacion.trim() ? 'Debe ingresar el comprador antes de buscar' : 'Buscar factura'"
              >
                <span v-if="buscandoFactura" class="campo-spinner-dot"></span>
                <span v-else>&#128269;</span>
              </button>
            </div>
            <span v-if="facturaEncontrada" class="campo-ok">&#10003; Factura seleccionada</span>
            <span v-if="!comprador.identificacion.trim()" class="campo-hint">Ingrese la identificación del comprador primero</span>
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Fecha Emisión Doc. Modificado <span class="campo-requerido">*</span></label>
            <input type="date" class="campo-input" v-model="docModificado.fechaEmision" />
          </div>
          <div class="nc-campo">
            <label class="campo-etiqueta">Motivo de la Nota de Crédito <span class="campo-requerido">*</span></label>
            <input type="text" class="campo-input" v-model="motivo" placeholder="Ej: Devolución de mercancía, error en precio..." />
          </div>
        </div>
        <div class="tipo-ajuste-bloque">
          <label class="campo-etiqueta">Tipo de nota de crédito <span class="campo-requerido">*</span></label>
          <select class="campo-select" v-model="tipoAjuste" @change="actualizarTipoAjuste">
            <option value="devolucion">Devolución de producto (repone inventario)</option>
            <option value="descuento">Descuento parcial (no modifica inventario)</option>
          </select>
          <span class="campo-hint" v-if="tipoAjuste === 'devolucion'">
            El precio, descuento e IVA se toman exactamente de la factura; solo puede cambiar la cantidad devuelta.
          </span>
          <span class="campo-hint" v-else>
            Ingrese el valor del descuento sin IVA. Esta opción no devuelve unidades al inventario.
          </span>
        </div>
      </div>
    </div>

    <!-- MODAL: SELECCIONAR FACTURA -->
    <div
      v-if="mostrarModalFacturas"
      class="modal-overlay"
      @click.self="cerrarModalFacturas"
    >
      <div class="modal-dialogo">
        <div class="modal-cabecera">
          <span class="modal-titulo">Seleccionar Factura</span>
          <button class="modal-cerrar" @click="cerrarModalFacturas" aria-label="Cerrar">&times;</button>
        </div>
        <div class="modal-cuerpo">
          <div class="nc-grid-3 mb-grilla">
            <div class="nc-campo">
              <label class="campo-etiqueta">Filtrar por número</label>
              <input
                type="text"
                class="campo-input"
                placeholder="001-001-000000001"
                v-model="filtroNumeroFactura"
                autofocus
              />
            </div>
            <div class="nc-campo">
              <label class="campo-etiqueta">Período</label>
              <select class="campo-select" v-model="diasRango" @change="buscarFactura">
                <option :value="30">Últimos 30 días</option>
                <option :value="60">Últimos 60 días</option>
                <option :value="90">Últimos 90 días</option>
                <option :value="0">Todos</option>
              </select>
            </div>
            <div class="nc-campo nc-campo-bottom">
              <button class="btn-primario btn-bloque" @click="buscarFactura" :disabled="buscandoFactura">
                <span v-if="buscandoFactura" class="campo-spinner-dot"></span>
                Actualizar
              </button>
            </div>
          </div>

          <div v-if="buscandoFactura" class="estado-cargando">
            <span class="spinner-grande"></span>
            <span class="estado-texto">Cargando facturas...</span>
          </div>
          <div v-else-if="facturasCliente.length === 0" class="estado-vacio">
            {{ diasRango > 0 ? `No se encontraron facturas en los últimos ${diasRango} días.` : 'No se encontraron facturas registradas para este comprador.' }}
          </div>
          <div v-else class="tabla-modal-wrap">
            <table class="tabla-modal">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Fecha</th>
                  <th class="alinear-derecha">Total</th>
                  <th style="width:110px"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="f in facturasFiltradas"
                  :key="f.id"
                  :class="{ 'fila-seleccionada': docModificado.facturaId === f.id }"
                >
                  <td class="td-negrita">{{ f.numero_factura }}</td>
                  <td>{{ f.fecha_emision?.slice(0, 10) }}</td>
                  <td class="alinear-derecha">$ {{ parseFloat(f.monto || 0).toFixed(2) }}</td>
                  <td>
                    <button
                      class="btn-seleccionar-factura"
                      :class="{ 'btn-seleccionada': docModificado.facturaId === f.id }"
                      @click="seleccionarFactura(f)"
                    >
                      {{ docModificado.facturaId === f.id ? '&#10003; Seleccionada' : 'Seleccionar' }}
                    </button>
                  </td>
                </tr>
                <tr v-if="facturasFiltradas.length === 0">
                  <td colspan="4" class="tabla-vacia">Sin resultados para el filtro ingresado.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-pie">
          <button class="btn-secundario" @click="cerrarModalFacturas">Cerrar</button>
        </div>
      </div>
    </div>


    <!-- DETALLES DE LA NC -->
    <div class="nc-tarjeta">
      <div class="nc-tarjeta-cabecera">
        <span>Detalles de la Nota de Crédito</span>
        <span v-if="cargandoDetallesFactura" class="buscador-spinner" title="Cargando productos de la factura..."></span>
      </div>
      <div class="nc-tarjeta-cuerpo">

        <!-- Tabla de detalles -->
        <div class="tabla-detalles-wrap">
          <table class="tabla-detalles">
            <thead>
              <tr>
                <th class="col-incluir alinear-centro">
                  <input
                    type="checkbox"
                    :checked="todosIncluidos"
                    :disabled="detalles.length === 0"
                    title="Seleccionar todos"
                    @change="alternarTodos($event.target.checked)"
                  />
                </th>
                <th class="col-codigo">Código</th>
                <th class="col-descripcion">Descripción</th>
                <th class="col-precio">Precio facturado</th>
                <th class="col-cant">{{ tipoAjuste === 'devolucion' ? 'Cant. a devolver' : 'Descuento sin IVA' }}</th>
                <th class="col-desc">Descuento proporcional</th>
                <th class="col-iva">IVA %</th>
                <th class="col-subtotal">Subtotal</th>
                <th class="col-accion"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in detalles"
                :key="idx"
                class="fila-detalle"
                :class="{ 'fila-excluida': !item.incluido }"
              >
                <td class="alinear-centro">
                  <input type="checkbox" v-model="item.incluido" />
                </td>
                <td>{{ item.codigo }}</td>
                <td>{{ item.descripcion }}</td>
                <td class="alinear-derecha">$ {{ item.precioUnitario.toFixed(2) }}</td>
                <td class="alinear-derecha">
                  <input
                    v-if="tipoAjuste === 'devolucion'"
                    type="number"
                    min="0.0001"
                    :max="item.cantidadOriginal"
                    step="0.01"
                    class="campo-cantidad"
                    v-model.number="item.cantidad"
                    :disabled="!item.incluido"
                    @input="calcularLinea(item)"
                  />
                  <div v-else class="campo-valor-descuento">
                    <span>$</span>
                    <input
                      type="number"
                      min="0.01"
                      :max="item.subtotalOriginalSinIva"
                      step="0.01"
                      class="campo-cantidad"
                      v-model.number="item.valorCredito"
                      :disabled="!item.incluido"
                      @input="calcularLinea(item)"
                    />
                  </div>
                </td>
                <td class="alinear-derecha">{{ tipoAjuste === 'devolucion' ? '$ ' + item.descuento.toFixed(2) : '—' }}</td>
                <td>{{ item.porcentajeIVA }}%</td>
                <td class="celda-subtotal">$ {{ item.subtotalSinIva.toFixed(2) }}</td>
                <td class="alinear-centro">
                  <button
                    type="button"
                    class="btn-quitar-detalle"
                    title="Quitar producto"
                    @click="eliminarDetalle(idx)"
                  >&times;</button>
                </td>
              </tr>
              <tr v-if="detalles.length === 0">
                <td colspan="9" class="tabla-vacia">Seleccione una factura para cargar los detalles de la nota de crédito.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- TOTALES -->
    <div class="nc-totales-wrap">
      <div class="nc-totales">
        <div class="totales-fila">
          <span>Subtotal 15%:</span>
          <span>$ {{ totales.subtotal15.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>Subtotal 5%:</span>
          <span>$ {{ totales.subtotal5.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>Subtotal 0%:</span>
          <span>$ {{ totales.subtotal0.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>Total sin impuestos:</span>
          <span>$ {{ totales.subtotalSinIva.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>Descuento total:</span>
          <span>$ {{ totales.descuentoTotal.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>IVA 15%:</span>
          <span>$ {{ totales.iva15.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>IVA 5%:</span>
          <span>$ {{ totales.iva5.toFixed(2) }}</span>
        </div>
        <div class="totales-fila">
          <span>Total IVA:</span>
          <span>$ {{ totales.iva.toFixed(2) }}</span>
        </div>
        <div class="totales-separador"></div>
        <div class="totales-fila totales-total">
          <span>Total:</span>
          <span>$ {{ totales.total.toFixed(2) }}</span>
        </div>
      </div>
    </div>

    <!-- ACCIONES -->
    <div class="nc-acciones">
      <router-link to="/ventas/documentos-emitidos" class="btn-secundario">Cancelar</router-link>
      <button
        type="button"
        class="btn-primario btn-negrita"
        @click.prevent="emitirNotaCredito"
        :disabled="procesando"
      >
        <span v-if="procesando" class="campo-spinner-dot"></span>
        Emitir Nota de Crédito
      </button>
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import notificationService from '@/services/notificationService'
import { mapGetters } from 'vuex'
import { fechaIsoSistema } from '@/utils/fechaSistema'

function hoy() {
  return fechaIsoSistema()
}

export default {
  name: 'ClientNotaCredito',

  data() {
    return {
      cabecera: {
        fechaEmision: hoy(),
        puntoEmisionId: '',
        ambiente: '',
      },
      secuencial: '',
      cargandoSecuencial: false,
      puntosEmision: [],
      cargandoPuntos: false,

      docModificado: {
        numero: '',
        fechaEmision: hoy(),
        facturaId: null,
      },
      facturaEncontrada: false,
      buscandoFactura: false,
      facturasCliente: [],
      diasRango: 60,
      filtroNumeroFactura: '',
      mostrarModalFacturas: false,
      motivo: '',
      tipoAjuste: 'devolucion',
      cargandoDetallesFactura: false,

      comprador: {
        tipoIdentificacion: '04',
        identificacion: '',
        razonSocial: '',
        correo: '',
        direccion: '',
      },

      detalles: [],
      procesando: false,
      sriTypes: [],
      loadingSriTypes: false,
      buscandoCliente: false,
      sugerenciasClientes: [],
      mostrarSugerencias: false,
      indiceSugerenciaActiva: -1,
      debounceTimer: null,
      productSearchQuery: '',
      productSuggestions: [],
      productSearchError: '',
      loadingProductSearch: false,
      productSearchTimer: null,
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
    todosIncluidos() {
      return this.detalles.length > 0 && this.detalles.every(d => d.incluido)
    },
    totales() {
      const resumen = this.detalles.filter(d => d.incluido).reduce((acc, d) => {
        const tarifa = Number(d.porcentajeIVA || 0)
        const base = Number(d.subtotalSinIva || 0)
        const iva = Number(d.iva || 0)

        if (tarifa >= 15) {
          acc.subtotal15 += base
          acc.iva15 += iva
        } else if (tarifa === 5) {
          acc.subtotal5 += base
          acc.iva5 += iva
        } else {
          acc.subtotal0 += base
        }

        acc.descuentoTotal += Number(d.descuento || 0)
        acc.iva += iva
        return acc
      }, {
        subtotal15: 0,
        subtotal5: 0,
        subtotal0: 0,
        descuentoTotal: 0,
        iva15: 0,
        iva5: 0,
        iva: 0,
      })

      const subtotalSinIva = resumen.subtotal15 + resumen.subtotal5 + resumen.subtotal0
      return {
        subtotal15: resumen.subtotal15,
        subtotal5: resumen.subtotal5,
        subtotal0: resumen.subtotal0,
        subtotalSinIva,
        descuentoTotal: resumen.descuentoTotal,
        iva15: resumen.iva15,
        iva5: resumen.iva5,
        iva: resumen.iva,
        total: subtotalSinIva + resumen.iva,
      }
    },
    facturasFiltradas() {
      const filtro = (this.filtroNumeroFactura || '').trim().toLowerCase()
      if (!filtro) return this.facturasCliente
      return this.facturasCliente.filter(f =>
        (f.numero_factura || '').toLowerCase().includes(filtro)
      )
    },
  },

  watch: {
    'cabecera.puntoEmisionId': {
      async handler(nuevoId) {
        if (nuevoId) {
          await this.cargarSecuencial(nuevoId)
        }
      },
    },
  },

  async mounted() {
    await Promise.all([this.cargarPuntosEmision(), this.cargarAmbiente(), this.fetchSriTypes()])
  },

  methods: {
    mostrarAlerta(mensaje, tipo = 'warning') {
      if (tipo === 'success') {
        notificationService.success(mensaje)
      } else if (tipo === 'danger' || tipo === 'error') {
        notificationService.error(mensaje)
      } else if (tipo === 'info') {
        notificationService.info(mensaje)
      } else {
        notificationService.warning(mensaje)
      }
    },

    async cargarPuntosEmision() {
      this.cargandoPuntos = true
      try {
        const { data } = await api.get('/configuracion/puntos-activos')
        this.puntosEmision = data.data || []
        if (this.puntosEmision.length > 0) {
          const principal = this.puntosEmision.find(p => p.is_main)
          this.cabecera.puntoEmisionId = (principal || this.puntosEmision[0]).id
        }
      } catch (e) {
        console.error('Error al cargar puntos de emisión:', e)
      } finally {
        this.cargandoPuntos = false
      }
    },

    async cargarSecuencial(puntoId) {
      this.cargandoSecuencial = true
      try {
        const { data } = await api.get('/configuracion/secuencial/next', {
          params: { eep_id: puntoId, document_type: '04' }
        })
        if (data.success && data.data) {
          this.secuencial = String(data.data.sequence).padStart(9, '0')
        }
      } catch (e) {
        console.error('Error al cargar secuencial:', e)
        this.secuencial = '000000001'
      } finally {
        this.cargandoSecuencial = false
      }
    },

    async cargarAmbiente() {
      try {
        const { data } = await api.get('/configuracion/ambiente-sri')
        if (data.success && data.data) {
          this.cabecera.ambiente = data.data.nombre
        }
      } catch (e) {
        console.error('Error al cargar ambiente:', e)
      }
    },

    async buscarFactura() {
      const identificacion = this.comprador.identificacion.trim()
      if (!identificacion) {
        this.mostrarAlerta('Ingrese la identificación del comprador antes de buscar.')
        return
      }
      this.buscandoFactura = true
      this.facturasCliente = []
      this.facturaEncontrada = false
      try {
        const params = {
          identificacion_comprador: identificacion,
          estado_sri: 5,
          limit: this.diasRango === 0 ? 500 : 100,
        }
        if (this.diasRango > 0) {
          const hoy = new Date()
          const desde = new Date(hoy)
          desde.setDate(hoy.getDate() - this.diasRango)
          params.fecha_desde = fechaIsoSistema(desde)
          params.fecha_hasta = fechaIsoSistema(hoy)
        }
        const { data } = await api.get('/facturas', { params })
        this.facturasCliente = data.data?.facturas || []
        if (this.facturasCliente.length === 0) {
          const periodo = this.diasRango > 0 ? `en los últimos ${this.diasRango} días` : 'registradas'
          this.mostrarAlerta(`No se encontraron facturas para este comprador ${periodo}.`)
        }
      } catch (e) {
        console.error('Error al buscar facturas:', e)
        this.mostrarAlerta('Error al consultar las facturas.', 'danger')
      } finally {
        this.buscandoFactura = false
      }
    },

    async abrirModalFacturas() {
      if (!this.comprador.identificacion.trim()) {
        this.mostrarAlerta('No existe comprador a buscar. Ingrese primero la identificación del comprador.')
        return
      }
      this.mostrarModalFacturas = true
      await this.buscarFactura()
    },

    cerrarModalFacturas() {
      this.mostrarModalFacturas = false
    },

    seleccionarFactura(f) {
      this.docModificado.facturaId = f.id
      this.docModificado.numero = f.numero_factura || ''
      this.docModificado.fechaEmision = f.fecha_emision?.slice(0, 10) || hoy()
      this.facturaEncontrada = true
      this.cerrarModalFacturas()
      this.cargarDetallesFactura(f.id)
    },

    async cargarDetallesFactura(facturaId) {
      this.cargandoDetallesFactura = true
      this.detalles = []
      try {
        const { data } = await api.get(`/facturas/${facturaId}`)
        this.rellenarDesdeFactura(data)
        const detallesOriginales = data.detalles || []
        this.detalles = detallesOriginales.map(d => this.normalizarDetalleFactura(d))
        if (this.detalles.length === 0) {
          this.mostrarAlerta('La factura seleccionada no tiene productos registrados.')
        }
      } catch (e) {
        console.error('Error al cargar detalles de factura:', e)
        this.mostrarAlerta('No se pudieron cargar los productos de la factura.', 'danger')
      } finally {
        this.cargandoDetallesFactura = false
      }
    },

    rellenarDesdeFactura(factura) {
      this.docModificado.facturaId = factura.id || this.docModificado.facturaId
      this.docModificado.numero = factura.numero_factura || this.docModificado.numero
      this.docModificado.fechaEmision = factura.fecha_emision?.slice(0, 10) || this.docModificado.fechaEmision
      this.facturaEncontrada = true

      const identificacion = factura.cliente_identificacion || ''
      const tipo = factura.cliente_tipo_identificacion || this.resolverTipoIdentificacion(identificacion)

      this.comprador.tipoIdentificacion = tipo || this.comprador.tipoIdentificacion
      this.comprador.identificacion = identificacion || this.comprador.identificacion
      this.comprador.razonSocial = factura.cliente_razon_social || factura.razon_social_comprador || this.comprador.razonSocial
      this.comprador.correo = factura.cliente_email || factura.correo_comprador || this.comprador.correo
      this.comprador.direccion = factura.cliente_direccion || factura.direccion_comprador || this.comprador.direccion
    },

    resolverTipoIdentificacion(valor) {
      const limpio = String(valor || '').replace(/[^0-9]/g, '')
      if (limpio.length === 13) return '04'
      if (limpio.length === 10) return '05'
      return limpio ? '06' : ''
    },

    normalizarDetalleFactura(d) {
      const cantidadOriginal = Number.parseFloat(d.cantidad || 0)
      const subtotalOriginalSinIva = Number.parseFloat(d.precio_total_sin_impuesto || d.subtotal || 0)
      const ivaOriginal = Number.parseFloat(d.iva || 0)
      const detalle = {
        incluido: true,
        facturaDetalleId: d.id,
        productoId: d.producto_id || null,
        codigo: d.codigo_principal || d.codigo || 'S/C',
        descripcion: d.descripcion || d.producto_nombre || '',
        precioUnitario: Number.parseFloat(d.precio_unitario || 0),
        cantidad: cantidadOriginal,
        cantidadOriginal,
        descuento: Number.parseFloat(d.descuento || 0),
        descuentoOriginal: Number.parseFloat(d.descuento || 0),
        porcentajeIVA: this.resolverPorcentajeIVA(d),
        subtotalSinIva: subtotalOriginalSinIva,
        subtotalOriginalSinIva,
        valorCredito: subtotalOriginalSinIva,
        iva: ivaOriginal,
        ivaOriginal,
        subtotal: Number.parseFloat(d.total_detalle || d.total || 0),
      }

      if (!detalle.subtotalSinIva || detalle.subtotalSinIva < 0) {
        detalle.subtotalSinIva = Math.max(0, (detalle.precioUnitario * detalle.cantidad) - detalle.descuento)
      }
      if (!detalle.iva && detalle.porcentajeIVA > 0) {
        detalle.iva = detalle.subtotalSinIva * (detalle.porcentajeIVA / 100)
      }
      detalle.subtotalOriginalSinIva = detalle.subtotalSinIva
      detalle.valorCredito = detalle.subtotalSinIva
      detalle.ivaOriginal = detalle.iva
      detalle.subtotal = detalle.subtotalSinIva + detalle.iva
      return detalle
    },

    alternarTodos(incluir) {
      this.detalles.forEach(d => { d.incluido = incluir })
    },

    actualizarTipoAjuste() {
      this.detalles.forEach(item => {
        item.cantidad = this.tipoAjuste === 'devolucion' ? item.cantidadOriginal : 1
        item.valorCredito = item.subtotalOriginalSinIva
        this.calcularLinea(item)
      })
    },

    resolverPorcentajeIVA(d) {
      const porcentaje = Number.parseFloat(d.porcentaje_iva)
      if (!Number.isNaN(porcentaje)) return porcentaje

      const codigoTarifa = String(d.sri_tarifas_iva || d.codigo_impuesto || '').trim()
      if (codigoTarifa === '4') return 15
      if (codigoTarifa === '2') return 5
      if (codigoTarifa === '0') return 0
      return 0
    },

    agregarDetalle() {
      this.detalles.push({
        incluido: true,
        productoId: null,
        codigo: '',
        descripcion: '',
        precioUnitario: 0,
        cantidad: 1,
        descuento: 0,
        porcentajeIVA: 15,
        subtotalSinIva: 0,
        iva: 0,
        subtotal: 0,
      })
    },

    eliminarDetalle(idx) {
      this.detalles.splice(idx, 1)
    },

    calcularLinea(item) {
      if (this.tipoAjuste === 'descuento') {
        const valor = Number(item.valorCredito || 0)
        const proporcion = item.subtotalOriginalSinIva > 0
          ? valor / item.subtotalOriginalSinIva
          : 0
        item.cantidad = 1
        item.descuento = 0
        item.subtotalSinIva = Math.max(0, valor)
        item.iva = Math.max(0, item.ivaOriginal * proporcion)
      } else {
        const cantidad = Number(item.cantidad || 0)
        const proporcion = item.cantidadOriginal > 0 ? cantidad / item.cantidadOriginal : 0
        item.subtotalSinIva = Math.max(0, item.subtotalOriginalSinIva * proporcion)
        item.iva = Math.max(0, item.ivaOriginal * proporcion)
        item.descuento = Math.max(0, (item.precioUnitario * cantidad) - item.subtotalSinIva)
      }
      item.subtotal = item.subtotalSinIva + item.iva
    },

    validar() {
      if (!this.docModificado.numero.trim()) return 'Ingrese el número de la factura a modificar.'
      if (!this.docModificado.facturaId) return 'Seleccione una factura autorizada para emitir la nota de crédito.'
      if (!['devolucion', 'descuento'].includes(this.tipoAjuste)) return 'Seleccione el tipo de nota de crédito.'
      if (!this.cabecera.puntoEmisionId) return 'Seleccione un punto de emisión.'
      if (!this.cabecera.fechaEmision) return 'Ingrese la fecha de emisión.'
      if (!this.docModificado.fechaEmision) return 'Ingrese la fecha del documento modificado.'
      if (!this.motivo.trim()) return 'Ingrese el motivo de la nota de crédito.'
      if (!this.comprador.tipoIdentificacion) return 'Seleccione el tipo de identificación.'
      if (!this.comprador.identificacion.trim()) return 'Ingrese la identificación del comprador.'
      if (!this.comprador.razonSocial.trim()) return 'Ingrese la razón social del comprador.'
      if (this.detalles.length === 0) return 'Agregue al menos un detalle.'
      const incluidos = this.detalles.filter(d => d.incluido)
      if (incluidos.length === 0) return 'Seleccione al menos un producto para la nota de crédito.'
      for (const d of incluidos) {
        if (!d.descripcion.trim()) return 'Complete la descripción de los productos seleccionados.'
        if (this.tipoAjuste === 'devolucion') {
          if (Number(d.cantidad) <= 0) return 'La cantidad devuelta debe ser mayor a 0.'
          if (Number(d.cantidad) > Number(d.cantidadOriginal) + 0.0001) {
            return 'La cantidad devuelta no puede superar la cantidad facturada.'
          }
        } else {
          if (Number(d.valorCredito) <= 0) return 'El valor del descuento debe ser mayor a 0.'
          if (Number(d.valorCredito) > Number(d.subtotalOriginalSinIva) + 0.005) {
            return 'El descuento no puede superar el subtotal facturado del producto.'
          }
        }
      }
      return null
    },

    emitirNotaCredito() {
      return this.guardar()
    },

    async guardar() {
      const error = this.validar()
      if (error) {
        this.mostrarAlerta(error)
        return
      }

      this.procesando = true
      try {
        const payload = {
          intent: 'ISSUE',
          punto_emision_id: this.cabecera.puntoEmisionId,
          fecha_emision: this.cabecera.fechaEmision,
          tipo_ajuste: this.tipoAjuste,
          factura_id: this.docModificado.facturaId || null,
          numero_doc_modificado: this.docModificado.numero,
          fecha_emision_doc_modificado: this.docModificado.fechaEmision,
          motivo: this.motivo,
          tipo_identificacion: this.comprador.tipoIdentificacion,
          identificacion_comprador: this.comprador.identificacion,
          razon_social_comprador: this.comprador.razonSocial,
          correo_comprador: this.comprador.correo || null,
          direccion_comprador: this.comprador.direccion || null,
          detalles: this.detalles.filter(d => d.incluido).map(d => ({
            factura_detalle_id: d.facturaDetalleId,
            producto_id: d.productoId || null,
            codigo: d.codigo || 'S/C',
            descripcion: d.descripcion,
            precio_unitario: d.precioUnitario,
            cantidad: d.cantidad,
            valor_credito_sin_iva: d.valorCredito,
            descuento: d.descuento,
            porcentaje_iva: d.porcentajeIVA,
          })),
        }

        // Paso 1: crear la NC lista para firmar.
        const { data } = await api.post('/notas-credito', payload)
        if (!data.success) {
          this.mostrarAlerta(data.error || 'Error al crear la nota de crédito.', 'danger')
          return
        }

        // Paso 2: firmar, generar XML y enviar al SRI
        const notaId = data.id
        this.mostrarAlerta('NC guardada. Firmando y enviando al SRI...', 'info')

        try {
          const { data: firma } = await api.post(`/notas-credito/${notaId}/firmar`)

          if (firma.success) {
            const numAut = firma.numero_autorizacion ? ` N.° ${firma.numero_autorizacion}` : ''
            this.mostrarAlerta(`Nota de crédito autorizada por el SRI.${numAut}`, 'success')
            setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 2500)
          } else if (firma.en_proceso) {
            this.mostrarAlerta('El SRI está procesando el comprobante. Puede consultar el estado en Documentos Emitidos.')
            setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 3000)
          } else {
            const msg = firma.message || firma.error || 'El SRI no autorizó el comprobante.'
            this.mostrarAlerta(`NC creada pero no autorizada. ${msg}`)
          }
        } catch (eFirma) {
          const statusFirma = eFirma.response?.status
          const dataFirma   = eFirma.response?.data

          if (statusFirma === 202 || dataFirma?.en_proceso) {
            this.mostrarAlerta('El SRI está procesando el comprobante. Consulte el estado en Documentos Emitidos.')
            setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 3000)
          } else {
            const msg = dataFirma?.message || dataFirma?.error || eFirma.message
            this.mostrarAlerta(`NC creada. Error al enviar al SRI: ${msg}`)
          }
        }

      } catch (e) {
        this.mostrarAlerta(e.response?.data?.error || 'Error al conectar con el servidor.', 'danger')
      } finally {
        this.procesando = false
      }
    },

    async fetchSriTypes() {
      this.loadingSriTypes = true
      try {
        const { data } = await api.get('/tipos-identificacion-sri')
        this.sriTypes = (data.data || data || [])
          .map(t => ({ code: t.code ?? t.codigo ?? '', name: t.name ?? t.tipo_de_identificacion ?? '' }))
          .filter(t => t.code !== '' && t.code !== '07')
      } catch (e) {
        this.sriTypes = [
          { code: '04', name: 'RUC' },
          { code: '05', name: 'Cédula' },
          { code: '06', name: 'Pasaporte' },
          { code: '08', name: 'Identificación del Exterior' },
        ]
      } finally {
        this.loadingSriTypes = false
      }
    },

    async buscarCompradorAutomatico(tipoBusqueda) {
      const identificacion = this.comprador.identificacion?.trim()
      const nombre = this.comprador.razonSocial?.trim()
      const valor = tipoBusqueda === 'identificacion' ? identificacion : nombre
      if (!valor || valor.length < 3) return
      this.buscandoCliente = true
      try {
        const { data } = await api.get('/clientes/buscar', { params: { q: valor, tipo: tipoBusqueda } })
        if (data.success && data.data) {
          const c = data.data
          const numId = c.identification_number || c.numero_ruc || identificacion
          this.comprador.identificacion = numId
          this.comprador.razonSocial = c.business_name || c.razon_social || nombre
          this.comprador.correo = c.email || this.comprador.correo
          this.comprador.direccion = c.address || c.direccion_matriz || this.comprador.direccion
          if (c.tipo_identificacion) {
            this.comprador.tipoIdentificacion = c.tipo_identificacion
          } else if (numId) {
            const len = numId.length
            this.comprador.tipoIdentificacion = len === 13 ? '04' : len === 10 ? '05' : '06'
          }
        }
      } catch (e) {
        console.log('Comprador no encontrado:', e.response?.data?.message || e.message)
      } finally {
        this.buscandoCliente = false
      }
    },

    buscarCompradorMientrasEscribe() {
      const query = this.comprador.razonSocial?.trim()
      if (this.debounceTimer) clearTimeout(this.debounceTimer)
      if (!query || query.length < 2) {
        this.sugerenciasClientes = []
        this.mostrarSugerencias = false
        return
      }
      this.debounceTimer = setTimeout(async () => {
        this.buscandoCliente = true
        try {
          const { data } = await api.get('/clientes/autocompletar', { params: { q: query, limit: 8 } })
          if (data.success && data.data) {
            this.sugerenciasClientes = data.data
            this.mostrarSugerencias = true
            this.indiceSugerenciaActiva = -1
          } else {
            this.sugerenciasClientes = []
          }
        } catch (e) {
          this.sugerenciasClientes = []
        } finally {
          this.buscandoCliente = false
        }
      }, 300)
    },

    seleccionarCliente(cliente) {
      const numId = cliente.identification_number || cliente.numero_ruc || ''
      this.comprador.identificacion = numId
      this.comprador.razonSocial = cliente.business_name || ''
      this.comprador.correo = cliente.email || this.comprador.correo
      this.comprador.direccion = cliente.address || cliente.direccion_matriz || this.comprador.direccion
      if (cliente.tipo_identificacion) {
        this.comprador.tipoIdentificacion = cliente.tipo_identificacion
      } else if (numId) {
        const len = numId.length
        this.comprador.tipoIdentificacion = len === 13 ? '04' : len === 10 ? '05' : '06'
      }
      this.cerrarSugerencias()
    },

    cerrarSugerencias() {
      this.sugerenciasClientes = []
      this.mostrarSugerencias = false
      this.indiceSugerenciaActiva = -1
    },

    cerrarSugerenciasConDelay() {
      setTimeout(() => this.cerrarSugerencias(), 200)
    },

    navegarSugerencia(direccion) {
      if (!this.mostrarSugerencias) return
      const max = this.sugerenciasClientes.length - 1
      this.indiceSugerenciaActiva = Math.max(-1, Math.min(max, this.indiceSugerenciaActiva + direccion))
    },

    seleccionarSugerenciaActiva() {
      if (this.indiceSugerenciaActiva >= 0 && this.sugerenciasClientes[this.indiceSugerenciaActiva]) {
        this.seleccionarCliente(this.sugerenciasClientes[this.indiceSugerenciaActiva])
      }
    },

    onProductSearchInput() {
      if (this.productSearchTimer) clearTimeout(this.productSearchTimer)
      const query = (this.productSearchQuery || '').trim()
      if (query.length >= 2) {
        this.productSearchTimer = setTimeout(() => { this.buscarProducto() }, 500)
      } else {
        this.productSearchError = ''
        this.productSuggestions = []
      }
    },

    async buscarProducto() {
      const query = (this.productSearchQuery || '').trim()
      if (!query) {
        this.productSearchError = 'Ingrese un código o nombre de producto.'
        return
      }
      this.loadingProductSearch = true
      this.productSearchError = ''
      try {
        const res = await api.get('/productos', {
          params: { filtros: JSON.stringify({ busqueda: query }), limit: 15, offset: 0 }
        })
        const list = res.data?.data?.productos || res.data?.productos || (Array.isArray(res.data?.data) ? res.data.data : [])
        if (list.length) {
          const queryUpper = query.toUpperCase()
          const exacto = list.find(
            p => (p.codigo_principal || '').toUpperCase() === queryUpper ||
                 (p.codigo_auxiliar  || '').toUpperCase() === queryUpper
          )
          if (exacto) {
            await this.selectProducto(exacto)
            return
          }
          this.productSuggestions = list
        } else {
          this.productSuggestions = []
          this.productSearchError = 'Producto no encontrado.'
        }
      } catch (e) {
        console.error('Error al buscar producto:', e)
        this.productSearchError = 'Error al buscar producto.'
        this.productSuggestions = []
      } finally {
        this.loadingProductSearch = false
      }
    },

    async selectProducto(p) {
      try {
        const preciosRes = await api.get(`/productos/${p.id}/precios`)
        const precios = preciosRes.data?.data || []
        const precio1 = precios.find(pr => pr.tipo_precio === 'Precio1')
        const precioDefault = precio1 ? parseFloat(precio1.precio) : parseFloat(p.precio_unitario || 0)
        const tarifa = parseFloat(p.tarifa_impuesto || 0)
        const detalle = {
          productoId: p.id,
          codigo: p.codigo_principal || '',
          descripcion: p.nombre_producto || '',
          precioUnitario: precioDefault,
          cantidad: 1,
          descuento: 0,
          porcentajeIVA: tarifa > 0 ? tarifa : 0,
          subtotalSinIva: 0,
          iva: 0,
          subtotal: 0,
        }
        this.calcularLinea(detalle)
        this.detalles.push(detalle)
      } catch (e) {
        const detalle = {
          productoId: p.id,
          codigo: p.codigo_principal || '',
          descripcion: p.nombre_producto || '',
          precioUnitario: parseFloat(p.precio_unitario || 0),
          cantidad: 1,
          descuento: 0,
          porcentajeIVA: parseFloat(p.tarifa_impuesto || 0),
          subtotalSinIva: 0,
          iva: 0,
          subtotal: 0,
        }
        this.calcularLinea(detalle)
        this.detalles.push(detalle)
      } finally {
        this.productSearchQuery = ''
        this.productSuggestions = []
        this.productSearchError = ''
      }
    },
  },
}
</script>

<style scoped>
/* ─── Contenedor principal ───────────────────────────────────────── */
.nc-pagina {
  padding: 1.5rem;
  background: var(--bg-main);
  color: var(--text-primary);
  min-height: 100%;
}

/* ─── Tarjeta (card) ─────────────────────────────────────────────── */
.nc-tarjeta {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: var(--shadow-sm);
}

.nc-tarjeta-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 14px;
  background: var(--primary-main);
  color: #fff;
  font-weight: 600;
  font-size: 0.88rem;
  border-radius: 7px 7px 0 0;
}

.nc-tarjeta-cuerpo {
  padding: 14px;
}

/* ─── Grid de campos ─────────────────────────────────────────────── */
.nc-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.nc-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

@media (max-width: 900px) {
  .nc-grid-4 { grid-template-columns: repeat(2, 1fr); }
  .nc-grid-3 { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 560px) {
  .nc-grid-4,
  .nc-grid-3 { grid-template-columns: 1fr; }
}

.nc-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nc-campo-doble {
  grid-column: span 2;
}

.nc-campo-bottom {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

/* ─── Etiquetas y estados de campo ───────────────────────────────── */
.campo-etiqueta {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.campo-requerido {
  color: var(--accent-danger);
}

.campo-ok {
  font-size: 0.82rem;
  color: var(--accent-success);
  margin-top: 2px;
}

.campo-hint {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin-top: 2px;
}

.tipo-ajuste-bloque {
  max-width: 620px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid var(--border-main);
  border-radius: 7px;
  background: var(--bg-main);
}

.tipo-ajuste-bloque .campo-hint {
  display: block;
  margin-top: 7px;
}

/* ─── Inputs y selects ───────────────────────────────────────────── */
.campo-input,
.campo-select {
  width: 100%;
  padding: 6px 10px;
  font-size: 0.88rem;
  border: 1px solid var(--border-main);
  border-radius: 6px;
  background: var(--bg-main);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.campo-input:focus,
.campo-select:focus {
  border-color: var(--border-focus);
  background: var(--secondary-bg-main);
}

.campo-input:disabled,
.campo-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.campo-select {
  cursor: pointer;
  appearance: auto;
}

/* ─── Campo con spinner interno ──────────────────────────────────── */
.campo-con-spinner {
  position: relative;
  display: flex;
  align-items: center;
}

.campo-con-spinner .campo-input {
  padding-right: 30px;
}

.campo-spinner-dot {
  position: absolute;
  right: 8px;
  width: 14px;
  height: 14px;
  border: 2px solid var(--border-main);
  border-top-color: var(--primary-main);
  border-radius: 50%;
  animation: girar 0.6s linear infinite;
  flex-shrink: 0;
}

/* Campo relativo (para sugerencias absolutas) */
.campo-relativo {
  position: relative;
}

/* ─── Campo con botón adjunto ────────────────────────────────────── */
.campo-con-boton {
  display: flex;
  gap: 0;
}

.campo-con-boton .campo-input {
  border-radius: 6px 0 0 6px;
  flex: 1;
}

.btn-campo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 10px;
  border: 1px solid var(--primary-main);
  border-left: none;
  border-radius: 0 6px 6px 0;
  background: var(--primary-main);
  color: #fff;
  cursor: pointer;
  font-size: 0.88rem;
  transition: background 0.15s;
  white-space: nowrap;
}

.btn-campo:hover:not(:disabled) {
  background: var(--primary-hover);
}

.btn-campo:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Sugerencias clientes ───────────────────────────────────────── */
.sugerencias-lista {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 2px 0 0;
  padding: 0;
  list-style: none;
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 6px;
  box-shadow: var(--shadow-md);
  max-height: 200px;
  overflow-y: auto;
}

.sugerencia-item {
  padding: 7px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-main);
  transition: background 0.1s;
}

.sugerencia-item:last-child {
  border-bottom: none;
}

.sugerencia-item:hover,
.sugerencia-activa {
  background: color-mix(in srgb, var(--primary-main) 12%, transparent);
}

.sugerencia-nombre {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
}

.sugerencia-id {
  font-size: 0.80rem;
  color: var(--text-muted);
}

/* ─── Buscador de producto ───────────────────────────────────────── */
.buscador-producto-wrap {
  position: relative;
  margin-bottom: 16px;
}

.campo-etiqueta {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.buscador-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.campo-input {
  width: 100%;
  padding: 6px 10px;
  font-size: 0.88rem;
  border: 1px solid var(--border-main);
  border-radius: 6px;
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.campo-input:focus {
  border-color: var(--border-focus);
}

.buscador-spinner {
  position: absolute;
  right: 10px;
  width: 14px;
  height: 14px;
  border: 2px solid var(--border-main);
  border-top-color: var(--primary-main);
  border-radius: 50%;
  animation: girar 0.6s linear infinite;
}

@keyframes girar {
  to { transform: rotate(360deg); }
}

.sugerencias-producto {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 2px 0 0;
  padding: 0;
  list-style: none;
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 6px;
  box-shadow: var(--shadow-md);
  max-height: 200px;
  overflow-y: auto;
}

.sugerencia-item {
  padding: 7px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-main);
  transition: background 0.1s;
}

.sugerencia-item:last-child {
  border-bottom: none;
}

.sugerencia-item:hover {
  background: color-mix(in srgb, var(--primary-main) 10%, transparent);
}

.campo-error {
  display: block;
  margin-top: 4px;
  font-size: 0.82rem;
  color: var(--accent-danger);
}

/* ─── Tabla de detalles ──────────────────────────────────────────── */
.tabla-detalles-wrap {
  overflow-x: auto;
  border: 1px solid var(--border-main);
  border-radius: 8px;
  margin-bottom: 12px;
}

.tabla-detalles {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;
  min-width: 720px;
}

.tabla-detalles thead th {
  background: var(--bg-main);
  color: var(--text-secondary);
  font-weight: 600;
  padding: 8px 10px;
  border-bottom: 2px solid var(--border-main);
  white-space: nowrap;
  text-align: left;
}

.tabla-detalles thead th.col-precio,
.tabla-detalles thead th.col-cant,
.tabla-detalles thead th.col-desc,
.tabla-detalles thead th.col-subtotal {
  text-align: right;
}

.tabla-detalles thead th.col-accion {
  width: 44px;
}

.tabla-detalles thead th.col-incluir   { width: 40px; }
.tabla-detalles thead th.col-codigo    { width: 110px; }
.tabla-detalles thead th.col-precio    { width: 110px; }
.tabla-detalles thead th.col-cant      { width: 90px; }
.tabla-detalles thead th.col-desc      { width: 90px; }
.tabla-detalles thead th.col-iva       { width: 90px; }
.tabla-detalles thead th.col-subtotal  { width: 95px; }

.alinear-centro { text-align: center; }

.campo-cantidad {
  width: 70px;
  padding: 3px 5px;
  text-align: right;
  border: 1px solid var(--border-main);
  border-radius: 4px;
  background: var(--bg-input, #fff);
  color: inherit;
}
.campo-cantidad:disabled {
  opacity: 0.5;
}

.campo-valor-descuento {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.fila-excluida {
  opacity: 0.5;
}

.btn-quitar-detalle {
  border: none;
  background: transparent;
  color: var(--danger, #d33);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 6px;
}
.btn-quitar-detalle:hover {
  color: #a00;
}

.fila-detalle td {
  padding: 2px 3px;
  border-bottom: 1px solid var(--border-main);
  vertical-align: middle;
}

.fila-detalle:last-child td {
  border-bottom: none;
}

.fila-detalle:focus-within {
  background: color-mix(in srgb, var(--primary-main) 5%, transparent);
}

/* Inputs dentro de celdas */
.celda-input,
.celda-select {
  width: 100%;
  padding: 5px 6px;
  font-size: 0.85rem;
  border: none;
  background: transparent;
  color: var(--text-primary);
  outline: none;
  box-shadow: none;
  box-sizing: border-box;
}

.celda-input:focus,
.celda-select:focus {
  background: var(--secondary-bg-main);
  border-radius: 4px;
  box-shadow: inset 0 0 0 2px var(--border-focus);
}

.celda-input.alinear-derecha {
  text-align: right;
}

.celda-select {
  cursor: pointer;
  appearance: auto;
}

/* Celda subtotal */
.celda-subtotal {
  text-align: right;
  font-weight: 600;
  padding: 5px 10px;
  color: var(--text-primary);
  white-space: nowrap;
}

/* Celda accion */
.celda-accion {
  text-align: center;
  padding: 2px 6px;
}

.btn-eliminar-fila {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: color 0.15s, background 0.15s;
  line-height: 1;
}

.btn-eliminar-fila:hover {
  color: var(--accent-danger);
  background: color-mix(in srgb, var(--accent-danger) 10%, transparent);
}

/* Fila vacia */
.tabla-vacia {
  text-align: center;
  padding: 20px;
  color: var(--text-muted);
  font-size: 0.85rem;
  font-style: italic;
}

/* Boton agregar item */
.btn-agregar-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px dashed var(--primary-main);
  border-radius: 6px;
  background: transparent;
  color: var(--primary-main);
  cursor: pointer;
  transition: background 0.15s, border-style 0.15s;
}

.btn-agregar-item:hover {
  background: color-mix(in srgb, var(--primary-main) 10%, transparent);
  border-style: solid;
}

/* ─── Sugerencias clientes ───────────────────────────────────────── */
.sugerencias-lista {
  top: 100%;
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-main);
  background-color: var(--secondary-bg-main);
  border-radius: 6px;
  box-shadow: var(--shadow-md);
}

/* ─── Modal seleccionar factura ──────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-dialogo {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border: 1px solid var(--border-main);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: var(--shadow-md);
}

.modal-cabecera {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--primary-main);
  border-radius: 9px 9px 0 0;
}

.modal-titulo {
  font-weight: 700;
  font-size: 0.92rem;
  color: #fff;
}

.modal-cerrar {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  opacity: 0.85;
  transition: opacity 0.15s;
}

.modal-cerrar:hover {
  opacity: 1;
}

.modal-cuerpo {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.modal-pie {
  flex-shrink: 0;
  background: var(--bg-main);
  border-top: 1px solid var(--border-main);
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
}

.mb-grilla {
  margin-bottom: 16px;
}

/* ─── Tabla en modal ─────────────────────────────────────────────── */
.tabla-modal-wrap {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid var(--border-main);
  border-radius: 6px;
}

.tabla-modal {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.83rem;
}

.tabla-modal thead th {
  position: sticky;
  top: 0;
  background: var(--bg-main);
  color: var(--text-secondary);
  font-weight: 600;
  padding: 8px 10px;
  border-bottom: 2px solid var(--border-main);
  text-align: left;
  z-index: 1;
}

.tabla-modal tbody td {
  padding: 7px 10px;
  border-bottom: 1px solid var(--border-main);
  color: var(--text-primary);
}

.tabla-modal tbody tr:last-child td {
  border-bottom: none;
}

.tabla-modal tbody tr:hover {
  background: color-mix(in srgb, var(--primary-main) 5%, transparent);
}

.fila-seleccionada {
  background: color-mix(in srgb, var(--primary-main) 12%, transparent) !important;
}

.td-negrita {
  font-weight: 600;
}

.alinear-derecha {
  text-align: right;
}

.btn-seleccionar-factura {
  padding: 3px 10px;
  font-size: 0.82rem;
  border: 1px solid var(--primary-main);
  border-radius: 5px;
  background: transparent;
  color: var(--primary-main);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}

.btn-seleccionar-factura:hover {
  background: var(--primary-main);
  color: #fff;
}

.btn-seleccionar-factura.btn-seleccionada {
  background: var(--primary-main);
  color: #fff;
}

/* ─── Estados vacío / cargando ───────────────────────────────────── */
.estado-cargando {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 0;
}

.estado-vacio {
  text-align: center;
  padding: 32px 0;
  font-size: 0.88rem;
  color: var(--text-muted);
}

.estado-texto {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.spinner-grande {
  display: block;
  width: 28px;
  height: 28px;
  border: 3px solid var(--border-main);
  border-top-color: var(--primary-main);
  border-radius: 50%;
  animation: girar 0.7s linear infinite;
}

@keyframes girar {
  to { transform: rotate(360deg); }
}

/* ─── Totales ────────────────────────────────────────────────────── */
.nc-totales-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.nc-totales {
  min-width: 280px;
  background: var(--secondary-bg-main);
  border: 1px solid var(--primary-main);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: var(--shadow-sm);
}

.totales-fila {
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
  padding: 3px 0;
  color: var(--text-primary);
}

.totales-separador {
  border-top: 1px solid var(--border-main);
  margin: 6px 0;
}

.totales-total {
  font-weight: 700;
  font-size: 0.95rem;
}

/* ─── Acciones ───────────────────────────────────────────────────── */
.nc-acciones {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

/* ─── Botones genéricos ──────────────────────────────────────────── */
.btn-primario {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  font-size: 0.88rem;
  border: none;
  border-radius: 6px;
  background: var(--primary-main);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
  text-decoration: none;
}

.btn-primario:hover:not(:disabled) {
  background: var(--primary-hover);
}

.btn-primario:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-negrita {
  font-weight: 600;
}

.btn-bloque {
  width: 100%;
  justify-content: center;
}

.btn-secundario {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  font-size: 0.88rem;
  border: 1px solid var(--border-main);
  border-radius: 6px;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  text-decoration: none;
}

.btn-secundario:hover:not(:disabled) {
  background: color-mix(in srgb, var(--text-primary) 8%, transparent);
  border-color: var(--text-secondary);
}

.btn-secundario:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

</style>

